var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0507 18H2.46193C1.63959 18 1 17.3604 1 16.5381V4.38583C1 3.5635 1.63959 2.9239 2.46193 2.9239H11.0507C11.8731 2.9239 12.5127 3.5635 12.5127 4.38583V16.4467C12.5127 17.3604 11.8731 18 11.0507 18Z",
    stroke: "#3399FA",
    strokeWidth: 1.5077,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7767 1.46196H2.91882V5.11678H10.7767V1.46196Z",
    fill: "#3399FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75618 2.92385C7.51311 2.92385 8.12673 2.26933 8.12673 1.46193C8.12673 0.654526 7.51311 0 6.75618 0C5.99924 0 5.38562 0.654526 5.38562 1.46193C5.38562 2.26933 5.99924 2.92385 6.75618 2.92385Z",
    fill: "#3399FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/paste-icon.13351be8.svg";
export { ForwardRef as ReactComponent };